import React from 'react'

import './divs.css'

const Component = (props) => {
  return (
  	<div className="window">
  		<div className="container">
  			{props.children}
  		</div>
  	</div>
  )
}

export default Component